export default {
  EVENT: 'EVENT',
  INVENTORY: 'INVENTORY',
  ITEMS: 'ITEMS',
}



// WEBPACK FOOTER //
// ./src/constants/checkoutModalTypes.js